import React from "react";

const VectorSand = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            {...props}
        >
            <defs>
                <filter id="sandNoise">
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.6"
                        numOctaves="3"
                        stitchTiles="stitch"
                    />
                    <feColorMatrix type="saturate" values="0" />
                    <feComponentTransfer>
                        <feFuncA type="linear" slope="0.2" />
                    </feComponentTransfer>
                </filter>
            </defs>

            {/* Layer 1: Wet Sand (Shoreline boundary) */}
            <path
                fill="#DEB887"
                d="M0,180 C300,190 600,185 900,200 C1200,215 1440,190 1440,190 V320 H0 V180 Z"
            />

            {/* Layer 2: Mid Sand */}
            <path
                fill="#E6C288"
                d="M0,220 C250,210 500,230 750,225 C1000,220 1250,240 1440,230 V320 H0 V220 Z"
            />

            {/* Layer 3: Dry Sand */}
            <path
                fill="#FFCC80"
                d="M0,250 C200,245 400,260 600,255 C800,250 1000,265 1200,260 C1300,258 1400,262 1440,265 V320 H0 V250 Z"
            />

            {/* Pebbles... */}
            <g stroke="none">
                {/* ... existing pebbles ... */}
                {/* Pebble 1: Largeish, left - Light Brown */}
                <ellipse cx="100" cy="205" rx="10" ry="7" transform="rotate(10 100 265)" fill="#D7CCC8" />
                {/* Pebble 2: Small, mid-left - White */}
                <circle cx="250" cy="225" r="5" fill="#F5F5F5" />
                {/* Pebble 3: Flat, left-center - Ivory */}
                <ellipse cx="400" cy="245" rx="12" ry="5" fill="#FFF9C4" />
                {/* Pebble 4: Tiny cluster, center - Light Brown */}
                <circle cx="600" cy="260" r="4" fill="#BCAAA4" />
                {/* Pebble 5: Round, center-right - White */}
                <circle cx="750" cy="275" r="8" fill="#FAFAFA" />
                {/* Pebble 6: Flat, right - Ivory */}
                <ellipse cx="900" cy="255" rx="14" ry="6" transform="rotate(-5 900 255)" fill="#FFF59D" />
                {/* Pebble 7: Small, far right - Light Brown */}
                <circle cx="1100" cy="290" r="5" fill="#A1887F" />
                {/* Pebble 8: Tiny, far left bottom - White */}
                <circle cx="50" cy="295" r="3" fill="#FFFFFF" />
                {/* Pebble 9: Mid size, right bottom - Ivory */}
                <ellipse cx="1300" cy="270" rx="9" ry="6" fill="#FFF176" />
                {/* Pebble 10: Near edge - Light Brown */}
                <circle cx="1400" cy="280" r="6" fill="#D7CCC8" />
                {/* Pebble 11: Low left - Light Brown */}
                <circle cx="180" cy="290" r="7" fill="#A1887F" />
                {/* Pebble 12: Mid left - White */}
                <ellipse cx="500" cy="250" rx="8" ry="5" transform="rotate(20 500 250)" fill="#FAFAFA" />
                {/* Pebble 13: Mid right - Ivory */}
                <circle cx="820" cy="293" r="6" fill="#FFF59D" />
                {/* Pebble 14: Right - Light Brown */}
                <ellipse cx="1000" cy="265" rx="10" ry="6" fill="#BCAAA4" />
                {/* Pebble 15: Far right high - White */}
                <circle cx="1200" cy="250" r="5" fill="#F5F5F5" />
                <circle cx="950" cy="285" r="4" fill="#A1887F" />
                <ellipse cx="60" cy="260" rx="9" ry="5" transform="rotate(-15 60 260)" fill="#FFF176" />
                <circle cx="1350" cy="255" r="7" fill="#EFEBE9" />
                <circle cx="700" cy="245" r="3" fill="#FFFFFF" />
                <ellipse cx="350" cy="295" rx="11" ry="6" transform="rotate(5 350 295)" fill="#D7CCC8" />
            </g>

            {/* Noise Overlay for Texture */}
            <rect width="100%" height="100%" filter="url(#sandNoise)" opacity="0.4" style={{ mixBlendMode: "overlay" }} />

            {/* Wave Wash (Foam/Water Overlaying Sand) */}
            <g className="vector-foam-wash">
                {/* Shallow Sea Wash on Sand */}
                <path
                    fill="#4FC3F7"
                    opacity="0.32"
                    d="M0,180 C300,190 600,185 900,200 C1200,215 1440,190 1440,190 V280 C1100,295 800,275 500,280 C200,285 0,270 Z"
                />

                {/* Foam Layer 1 */}
                <path
                    fill="#FFFFFF"
                    opacity="0.45"
                    d="M0,180 C300,190 600,185 900,200 C1200,215 1440,190 1440,190 V250 C1100,260 850,240 550,245 C250,250 0,235 Z"
                />

                {/* Foam Layer 2 (Edge detail) */}
                <path
                    fill="#FFFFFF"
                    opacity="0.75"
                    d="M0,180 C300,190 600,185 900,200 C1200,215 1440,190 1440,190 V215 C1100,225 800,210 500,215 C200,220 0,210 Z"
                />
            </g>
        </svg>
    );
};

export default VectorSand;
